<template>
  <v-form v-model="valid" ref="mainForm">
    <CaseACocherLive
      code="sans_emploi"
      v-model="sas.sasInscriptionTableau.sansEmploi"
      :live="{
        endpoint: 'sas-inscription-tableau',
        cle: 7709,
        fileId: sas.sasInscriptionTableau.id,
      }"
      :opqIf="sas.adressesProfessionnelles.length === 0"
      ref="sansEmploi"
      :disabled="estRetraite || estInvalidite"
    />
    <data-iterator
      :list="sas.adressesProfessionnelles"
      :live="{}"
      :icon="$getIcon('job')"
      ref="dataIterator"
      hidePoints
      hideAddButton
      :optional="true"
    >
      <template v-slot:show-mode="{ item }">
        <OrganisationCardContent v-if="item" :organisation="item" />
      </template>
    </data-iterator>
    <v-alert color="primary" text class="pl-8 mb-8" max-width="600">
      <ressource code="domicile_professionnel" />
      <div class="mt-3">
        {{ domicileProfessionnel }}
      </div>
    </v-alert>
  </v-form>
</template>
<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import RelationSasAdresse from "@/mixins/RelationSasAdresse"
import OrganisationCardContent from "@/components/Common/OrganisationCardContent.vue"
import { eventBus } from "@/plugins/eventBus"
import { nextTick } from "vue"

export default {
  mixins: [StepFormWithValidation, CataloguesHelpers, RelationSasAdresse],
  components: {
    OrganisationCardContent,
  },
  props: {
    sas: { type: Object },
  },
  created() {
    eventBus.$on("categorieChanged", this.modifierLieuxDExercices)
  },
  computed: {
    estMembre() {
      return (
        this.getCatalogueCodeById(
          "11136",
          this.sas.sasInscriptionTableau.categorieDeMembre
        ) == "membre"
      )
    },
    estInvalidite() {
      return (
        this.getCatalogueCodeById(
          "11136",
          this.sas.sasInscriptionTableau.categorieDeMembre
        ) == "inv"
      )
    },
    estRetraite() {
      return (
        this.getCatalogueCodeById(
          "11136",
          this.sas.sasInscriptionTableau.categorieDeMembre
        ) == "retraite"
      )
    },
    domicileProfessionnel() {      
      const sasAdresse = this.sas.adressesProfessionnelles.find(
        (x) => x.domicileProfessionnel === true
      )
      if (sasAdresse) {
        return sasAdresse.organisation + " - " + sasAdresse.rue1
      }

      return ""
    },
  },
  methods: {
    modifierLieuxDExercices() {
      if (this.estMembre) {
        this.activerLieuxDExercices()
      } else if (this.estInvalidite || this.estRetraite) {
        this.desactiverLieuxDExercices()
      }
    },
    activerLieuxDExercices() {
      this.cocherSansEmploi(false)
    },
    desactiverLieuxDExercices() {
      // On attend le rendu des v-if
      nextTick(() => {
        this.cocherSansEmploi(true)
      })
    },
    cocherSansEmploi(cocher) {
      let refSansEmploi = this.$refs["sansEmploi"]
      refSansEmploi.setValue(cocher)
    },
  },
}
</script>

<style></style>
